"use client";

import { c as _c } from "react/compiler-runtime";
import { BookIcon, ChevronDownIcon } from "lucide-react";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { cn } from "@/lib/utils";
import type { ComponentProps } from "react";
export type SourcesProps = ComponentProps<"div">;
export const Sources = t0 => {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("not-prose mb-4 text-primary text-xs", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <Collapsible className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export type SourcesTriggerProps = ComponentProps<typeof CollapsibleTrigger> & {
  count: number;
};
export const SourcesTrigger = t0 => {
  const $ = _c(14);
  let children;
  let className;
  let count;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      count,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = count;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    count = $[3];
    props = $[4];
  }
  let t1;
  if ($[5] !== className) {
    t1 = cn("flex items-center gap-2", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== children || $[8] !== count) {
    t2 = children ?? <><p className="font-medium">Used {count} sources</p><ChevronDownIcon className="h-4 w-4" /></>;
    $[7] = children;
    $[8] = count;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== props || $[11] !== t1 || $[12] !== t2) {
    t3 = <CollapsibleTrigger className={t1} {...props}>{t2}</CollapsibleTrigger>;
    $[10] = props;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
};
export type SourcesContentProps = ComponentProps<typeof CollapsibleContent>;
export const SourcesContent = t0 => {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("mt-3 flex w-fit flex-col gap-2", "data-[state=closed]:fade-out-0 data-[state=closed]:slide-out-to-top-2 data-[state=open]:slide-in-from-top-2 outline-none data-[state=closed]:animate-out data-[state=open]:animate-in", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <CollapsibleContent className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export type SourceProps = ComponentProps<"a">;
export const Source = t0 => {
  const $ = _c(12);
  let children;
  let href;
  let props;
  let title;
  if ($[0] !== t0) {
    ({
      href,
      title,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = href;
    $[3] = props;
    $[4] = title;
  } else {
    children = $[1];
    href = $[2];
    props = $[3];
    title = $[4];
  }
  let t1;
  if ($[5] !== children || $[6] !== title) {
    t1 = children ?? <><BookIcon className="h-4 w-4" /><span className="block font-medium">{title}</span></>;
    $[5] = children;
    $[6] = title;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== href || $[9] !== props || $[10] !== t1) {
    t2 = <a className="flex items-center gap-2" href={href} rel="noreferrer" target="_blank" {...props}>{t1}</a>;
    $[8] = href;
    $[9] = props;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};